export const getOrQueryString = (
  filters: Record<string, string | string[] | undefined>
): string | undefined => {
  const finalObject: Record<string, string | string[] | undefined> = {}

  for (const key in filters) {
    const value = filters[key]
    if (Array.isArray(value) && value.length === 0) continue
    finalObject[key] = value
  }

  const queryString = JSON.stringify(finalObject)

  return queryString === "{}" ? undefined : queryString
}

export const navigateToBlank = (url?: string) => {
  if (url && url.length > 0) window.open(url, "_blank")
}

// External link target from a URL of the data: http(s) as is, "www.example.com" (no scheme) as
// https, anything else (javascript:, data:…) undefined so that it is shown as text, never as a link.
export const toSafeExternalUrl = (url?: string | null): string | undefined => {
  const trimmed = url?.trim()
  if (!trimmed) return undefined
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return undefined

  return `https://${trimmed.replace(/^\/+/, "")}`
}
